import React, { useState } from "react";
import "./DetailCards.scss";

const cards = [
  { label: "locations", icon: "/dataguardIcons/locationWhite.svg", name: "Locations"},
  { label: "behaviormodels", icon: "/dataguardIcons/behaviorWhite.svg", name: "Behaviour Model" },
  { label: "publicdata", icon: "/dashboardIcons/publicActiveWhite.svg", name: "Public Data" },
  { label: "roles", icon: "/dataguardIcons/rolesWhite.svg", name: "Roles" },
];

const DetailCards = ({ onSelect, selected }) => {

  return (
    <div className="detail-cards-container">
      {cards.map((card) => (
        <div
          key={card.label}
          className={`detail-card ${selected === card.label ? "active" : ""} ${card.label}`}
          onClick={() => onSelect(card.label)}
        >
          {/* Placeholder for icon */}
          <div className="detail-card-icon"><img src={card.icon} title={card.label}/></div>
          <div className="detail-card-label">{card.name}</div>
        </div>
      ))}
    </div>
  );
};

export default DetailCards;
